import React from 'react';
import { Container, GlobalLinkZoneModal, Balloon, Button, Icon } from './style';
import {
  useIsLinkArrowShown,
  useNodeLinkingOperations,
} from 'state/canvas/node-linking';
import { useGlobalLinks } from 'state/canvas/node-linking/global-links';
import { useSelectedNode } from 'state/canvas/selected-node';
import { useTranslation } from 'i18n';
import { ReactComponent as GlobalLinkIcon } from 'styles/icons/global-link.svg';
import surfaceNode from 'graphql/surface-node/queries/surface-node';
import { notEmpty } from 'utils/js';
import { isNull } from 'lodash';
import toast from 'services/toast';
import { isMobile } from 'react-device-detect';
import { SurfaceNodeUnion } from 'graphql/types';

export default function GlobalLinkZoneIndicator() {
  const { t } = useTranslation();
  const isLinkArrowShown = useIsLinkArrowShown();
  const { getCurrentLink, removeLinkArrow } = useNodeLinkingOperations();

  const [globalLinks, { addGlobalLink }] = useGlobalLinks();
  const [selectedNode, setSelectedNode] = useSelectedNode();
  const [isModalVisible, setModalVisibility] = React.useState(false);
  const modal = React.useRef<any>(null);

  const isButtonVisible =
    isLinkArrowShown || isModalVisible || notEmpty(globalLinks);

  // This handler should have 3 actions
  // 1. Storing global link
  // 2. Linking 2 nodes globally
  // 3. Showing modal
  function onClick() {
    if (isButtonVisible) {
      const { from, to } = getCurrentLink() || {};

      if (isLinkArrowShown && from?.id && isNull(to)) {
        return saveGlobalLink();
      }

      showModal();
    }
  }

  function saveGlobalLink() {
    const { from } = getCurrentLink() || {};

    if (from) {
      addGlobalLink({ from: from as SurfaceNodeUnion, to: null });
      removeLinkArrow();
      toast.success(t('Successfully added node to global linking process.'));
    }
  }

  function showModal() {
    if (notEmpty(globalLinks)) {
      const [globalLink] = globalLinks;

      surfaceNode({ id: globalLink.from.id }).then((response) => {
        if (response.isSuccess) {
          modal.current.setData({ node: response.getField('data') });
          modal.current.show();
          setModalVisibility(true);

          if (selectedNode) {
            setSelectedNode(null);
          }
        }
      });
    }
  }

  function hide() {
    setModalVisibility(false);
  }

  return (
    <Container>
      <GlobalLinkZoneModal ref={modal} onHide={hide} />

      <Button
        isVisible={isButtonVisible}
        {...(isMobile ? { onTouchStart: onClick } : { onClick })}
        alternativeColorScheme={isModalVisible}>
        {notEmpty(globalLinks) && <Balloon>{globalLinks.length}</Balloon>}
        <Icon>
          <GlobalLinkIcon />
        </Icon>
      </Button>
    </Container>
  );
}
